import React from 'react';
import {
  Box,
  Select, MenuItem,
} from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { useTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';



const CustomBarCharts = ({ chartData, view, setView, options }) => {
  const theme = useTheme();
  const barColors = ['#B3BEC566', '#FAEF9B', '#B3BEC5', '#1C1C1C'];

  return (
    <Box sx={{ width: "100%", height: 350 }}>
      {/* Header with Select above chart */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Select
          size="small"
          value={view}
          onChange={(e) => setView(e.target.value)}
          IconComponent={KeyboardArrowDownIcon}
          sx={{
            color: 'var(--Primary-100, #393D44)',
            fontFamily: 'Marcellus, sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            textAlign: 'center',
            border: 'none',
            boxShadow: 'none',
            '.MuiOutlinedInput-notchedOutline': { border: 'none' },
            paddingRight: '16px',
          }}
        >
          {options.map((opt) => (
            <MenuItem
              key={opt.value}
              value={opt.value}
              sx={{
                fontFamily: 'Marcellus, sans-serif',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
                color: 'var(--Primary-100, #393D44)',
                textAlign: 'center',
              }}
            >
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </Box>


      {/* Chart */}
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <XAxis dataKey={chartData[0]?.treatment !== undefined ? 'treatment' : 'category'} axisLine={false} tickLine={false}
            tick={{ fontSize: 12 }}
          />
          <YAxis axisLine={false} tickLine={false}
            tick={{ fontSize: 12 }}
          />
          <Tooltip cursor={false} />

          <Bar
            dataKey="value"
            fill={theme.palette.primary.main}
            radius={[6, 6, 0, 0]}
            barSize={40}
            isAnimationActive={false}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={barColors[index % barColors.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CustomBarCharts;